// extracted by mini-css-extract-plugin
module.exports = {"ProductCard":"ProductCard_ProductCard__x8GVw"};